module.exports = __webpack_public_path__ + "static/media/BillingActive.36ad6602.svg";